import { useEffect, useState } from 'react';
import { CustomScrollDiv } from '../../components/custom-scroll-div/CustomScrollDiv';
import { useSocketInstance } from '../../context/SocketContext';
import moment from 'moment';
import { Link } from 'react-router-dom';
import {  NotifiactionBell } from '../../assets/common-svg/CommonSvg';
import NotifiactionApi from '../../services/notofiactionService';
import {  useSelector } from 'react-redux';
import NoDataCard from '../../components/no-data-card';
import SkeletonLoader from '../../utilites/SkeltonLoader';
import { SpinnerLoader } from '../../assets/loader/loader';
import InfiniteScroll from 'react-infinite-scroll-component';
import { notify } from '../../bmr/utils/methods/notification';
let notifiactionFilter = {
  page: 1,
  limit: 10,
  maxPages: null,
};
const Notifications = ({ renderNotification = 0, loading = false, setLoading = () => { } }) => {
  const loginID = useSelector((state) => state.loginData.loginId);
  const { socketInstance, setNotifiactionCount, allNotifiaction, setAllNotifiaction } = useSocketInstance();
  const [spinner, setSpinner] = useState(false);

  const handleReceiveMessage = (data) => {
    setNotifiactionCount(data)
  };
  useEffect(() => {
    if (!socketInstance?.connected) return
    emitMessage()
  }, [socketInstance]);

  useEffect(() => {
    if (renderNotification > 0) {
      setLoading(true)
      setNotifiactionCount(0)
      getNotifiaction()
    }
  }, [renderNotification])


  const emitMessage = () => {
    socketInstance.on("receive_notification", handleReceiveMessage);
  };

  const emitNotifiactionCount = () => {
    socketInstance.emit("count_notifiaction", { userId: loginID });
  };

  const getNotifiaction = () => {
    notifiactionFilter.page === 1 && setLoading(true);
    NotifiactionApi.getNotifiactionList(
      notifiactionFilter.limit,
      notifiactionFilter.page
    ).then(res => {
      if (res?.success == false) {
        setAllNotifiaction([]);
      } else {
        notifiactionFilter.maxPages = Math.ceil(
          res.page_details.no_of_records / notifiactionFilter.limit
        );
        res.page_details.page > 1
          ? setAllNotifiaction((prev) => [...prev, ...res.data])
          : setAllNotifiaction(res.data);
      }
      setLoading(false)
      setSpinner(false)
    }).catch(() => {
      setLoading(false)
      setSpinner(false)
    })
  }


  useEffect(() => {
    ResetFilter();
    getNotifiaction();
    PageIncrement()
  }, []);




  const readNotifiaction = (id) => {
    setLoading(true)
    NotifiactionApi.updateNotifiaction(id).then(() => {
      emitNotifiactionCount()
      getNotifiaction()
    }).catch(err => {
      notify.error(err)
      setLoading(false)
    })
  }

  const PageIncrement = () => {
    notifiactionFilter.page++;
  };
  const ResetFilter = () => {
    notifiactionFilter.page = 1;
  };

  const fetchData = () => {
    if (notifiactionFilter?.page <= notifiactionFilter?.maxPages) {
      getNotifiaction();
      PageIncrement();
    }
  }

  return (
    <div className='flex flex-col gap-4 '>
      <div className='overflow-auto scroll-smooth bg-white pl-[15px]'>
        {loading
          ? <SkeletonLoader rowCount={5} isTable={false} />
          : allNotifiaction && allNotifiaction?.length == 0
            ? <div className="mt-4">
              <NoDataCard />
            </div>
            : <InfiniteScroll
              className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4"
              dataLength={allNotifiaction?.length}
              next={fetchData}
              hasMore={notifiactionFilter?.page <= notifiactionFilter?.maxPages}
              loader={
                spinner && (
                  <div className="flex justify-center">
                    {" "}
                    <SpinnerLoader />
                  </div>
                )
              }
              scrollThreshold={0.9} // Adjust this value as needed
            >
              {allNotifiaction?.map((notify, index) => (
                <Link to={notify?.redirect_url} key={index} className='flex gap-4 border-b border-[#d5d5d5] ' onClick={() => readNotifiaction(notify?.id)}>
                  {/* <div key={index} className='flex gap-4 border-b border-[#d5d5d5] ' > */}
                  <span className='align-self-center'> <NotifiactionBell /></span>
                  <CustomScrollDiv heading={notify?.message} subHeading={moment(notify?.created_at).utc().format("DD/MM/YYYY hh:mm a")} />
                  {/* </div> */}
                </Link>
              ))}
            </InfiniteScroll>}
      </div>
    </div>
  );
};

export default Notifications;
